module.exports = __webpack_public_path__ + "img/review.0708aaee.png";